import React, { Component } from 'react'
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import LoginBox from '../layout/LoginBox';
import Loading from '../layout/Loading';
import Logo from '../icons/Logo';
import Button from '../layout/Button';
import FullPageBackground from '../layout/FullPageBackground';

import styles from './organisations.scss';

class Organisations extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();
    const { history } = this.props;
    history.push(`/organisations/${this.refs.selectedOrganisation.value}/profiles`);
  }

  render() {
    const { t, loading, name, organisations } = this.props;

    if(organisations.length === 1)
      return <Redirect to={`/organisations/${organisations[0].id}/profiles`} />

    return (
      <FullPageBackground>
        <LoginBox>
          {loading && <Loading text="Loading your organisations" />}
          <p className="welcome-message"><b>{t("WELCOME")} {name},</b><br /></p>
          <div className="form-group">
            <label htmlFor="organisations">{t("PLEASE_SELECT_ORGANISATION")}:</label>
            <select name="organisations" ref="selectedOrganisation">
              {organisations.map(organisation =>
                <option key={organisation.id} value={organisation.id}>{organisation.name}</option>
              )}
            </select>
          </div>
          <div className="form-group">
            <Button className="submit-organisation-btn" onClick={this.onSubmit}>
              {t("PROCEED")}
            </Button>
          </div>
        </LoginBox>
      </FullPageBackground>
    );
  }
}

export default translate('select organisation')(connect(
  ({ currentUser, organisations }) => ({
    name: currentUser.profile ? `${currentUser.profile.first_name} ${currentUser.profile.last_name}` : "",
    loading: organisations.fetching || currentUser.fetching,
    organisations: organisations.data
  })
)(Organisations));



// WEBPACK FOOTER //
// ./src/components/pages/Organisations.js